/**
 * @typedef {string} tabId
 */

/**
 * SAMC screen tabs
 *
 * @enum {tabId}
 */
export default {
    SERVICE_CASE_SEARCH: 'service-case-search',
    TASK_SEARCH: 'task-search',
    CONTRACT_PARTNER_SEARCH: 'contract-partner-search',
};
